module.exports = __webpack_public_path__ + "img/color_gray.6ef5edd3.svg";